module.exports = __webpack_public_path__ + "static/media/innovationtech.481c524a.png";